import { PageVisibleState, PageVisibleValueOrigin } from '../../types';
export var pageVisibleValue = function pageVisibleValue(_config, data, globalConfig) {
  var value = globalConfig.pageVisibleValueOrigin === PageVisibleValueOrigin.documentHidden ? !document.hidden || false : data.pageVisibleState === PageVisibleState.VISIBLE;
  return {
    'pageVisible:value': value
  };
};